// Created by hejikun on 2017/11/2 0002.
let ask2 = [
    // 服务模块 start
    {
      path: '/ask2',
      name: '在线咨询',
      component: () => import('@/pages/ask2/index')
    },
    {
      path: '/ask2OrderCreate',
      name: '创建咨询订单',
      component: () => import('@/pages/ask2/ask2Server/ask2OrderCreate')
    },
    // 服务模块 end

    // 科室模块 start
    {
      path: '/ask2DepList',
      name: '科室列表',
      component: () => import('@/pages/ask2/ask2DepList/ask2DepList')
    },
    // 科室模块 end


    // 订单模块 start
    {
      path: '/ask2OrderDetail',
      name: '咨询订单详情',
      component: () => import('@/pages/ask2/ask2Order/ask2OrderDetail')
    },
    {
      path: '/ask2OrderDetailList',
      name: '咨询订单列表',
      component: () => import('@/pages/ask2/ask2Order/ask2OrderDetailList')
    },
    //评价
    {
      path: '/ask2OrderRating',
      name: '评价',
      component: () => import('@/pages/ask2/ask2Order/ask2OrderRating')
    },
    
    // 订单模块 end

    // 搜索模块 start
    {
      path: '/ask2Search/ask2SearchIndex',
      name: '咨询首页搜索',
      component: () => import('@/pages/ask2/ask2Search/ask2SearchIndex.vue')
    },
    // 搜索模块 end

    //im start
    {
      path: '/ask2Search/ask2ChatRoom',
      name: '聊天室',
      component: () => import('@/pages/ask2/ask2ChatRoom/index.vue')
    },
    {
      path: '/ask2/questionnaire',
      name: '问卷填写',
      component: () => import('@/pages/ask2/ask2ChatRoom/compontents/messageTypeCompontents/systemMessage/systemMessageCompontents/questionnaire.vue')
    },
    
    //im end

    // 医生模块 start
    // 医生列表
    {
      path: '/ask2Doctor/ask2DoctorList',
      name: '医生列表',
      component: () => import('@/pages/ask2/ask2Doctor/ask2DoctorList.vue')
    },
    {
      path: '/ask2Doctor/ask2ScanPromotionDoctorList',
      name: 'ask2ScanPromotionDoctorList',
      component: () => import('@/pages/ask2/ask2Doctor/ask2ScanPromotionDoctorList.vue')
    },
    {
      path: '/ask2Doctor/ask2DoctorListForFree',
      name: '免费医生列表',
      component: () => import('@/pages/ask2/ask2Doctor/ask2DoctorListForFree.vue')
    },
    // 医生分组列表
    {
      path: '/ask2Doctor/ask2CategoryDoctorList',
      name: '医生分组列表',
      component: () => import('@/pages/ask2/ask2Doctor/ask2ActiveDoctorList.vue')
    },
    // 医生详情
    {
      path: '/ask2Doctor/ask2DoctorDetail',
      name: '医生详情',
      component: () => import('@/pages/ask2/ask2Doctor/ask2DoctorDetail.vue')
    },
    // 医生评价
    {
      path: '/ask2Doctor/askEvaluate',
      name: '医生评价',
      component: () => import('@/pages/ask2/ask2Doctor/askEvaluate.vue')
    },
    
    // 医生模块 end
  ]
  
  export default ask2
  